import React from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import Typography from "aldoo-ra/Typography"
import Button from "aldoo-ra/Button"
import StatisticsCardsShort from "../../StatisticsCardsShort.jsx"

const HeaderSectionLeft = ({ data }) => {
  if (!data) return null
  
  return (
    <div className="flex flex-col w-full md:w-[55%] lg:w-[60%] xl:w-[50%] justify-start items-start">
      {/* Left Section (Texts and button) */}
      <div className="flex flex-col w-full max-w-[800px] items-center md:items-start md:pt-[50px] lg:pt-[85px]">
        {/* Title */}
        <Typography
          component="h1"
          variant="title2"
          className="w-full text-center md:text-left mb-4 md:mb-[25px]"
        >
          {data?.title ?? ""}
        </Typography>

        {/* Subtitle */}
        <Typography
          variant="subtitle_signature"
          className="w-full max-w-[300px] md:max-w-[400px] lg:max-w-full text-center md:text-left mb-8 md:mb-10 lg:mb-[56px]"
        >
          {data?.description ?? ""}
        </Typography>

        {/* CTA Buttons and Statistics */}
        <div className="flex flex-col-reverse md:flex-col items-start gap-8 md:gap-10 lg:gap-[56px]">
          <div className="flex items-center gap-6">
            {data.menu?.map((item, index) => {
              const variant = index === 0 ? "primary_accent_xl" : "secondary_xl"
              return (
                <Button key={index} variant={variant}>
                  {item?.label ?? ""}
                </Button>
              )
            })}
          </div>

          {/* Statistics Cards - Android Only */}
          <StatisticsCardsShort />
        </div>
      </div>
    </div>
  )
}

export default HeaderSectionLeft
